import { render, staticRenderFns } from "./QuoteEditor.vue?vue&type=template&id=63156d82&"
import script from "./QuoteEditor.vue?vue&type=script&lang=js&"
export * from "./QuoteEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "QuoteEditor.vue"
export default component.exports